import React, { useContext } from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ContainerRecaptcha } from "./styles";
import { Input } from "../../Input";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";

export const Recaptcha: React.FC = () => {
  const { theme } = useTheme();
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);

  const dados = configuracoes.dados_recaptcha || {
    ativo: false,
    chave_site: "",
    chave_secreta: "",
  };

  return (
    <ContainerRecaptcha theme={theme}>
      <div className="texto fonteTexto">
        O reCAPTCHA v2 do Google adiciona uma validação de segurança antes de
        finalizar o pedido, dificultando tentativas automatizadas de pagamento
        (robôs). <br />
        Informe as chaves do seu site reCAPTCHA v2.
      </div>
      <div className="box">
        <div className="input">
          <Input
            type="text"
            label="Chave do site"
            value={dados.chave_site}
            maxLength={255}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_recaptcha: { ...dados, chave_site: newValue },
              });
            }}
            placeholder="Insira a chave do site (site key)"
          />
        </div>
        <div className="input">
          <Input
            type="text"
            label="Chave secreta"
            value={dados.chave_secreta}
            maxLength={255}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_recaptcha: { ...dados, chave_secreta: newValue },
              });
            }}
            placeholder="Insira a chave secreta (secret key)"
          />
        </div>
      </div>
    </ContainerRecaptcha>
  );
};
